import {Button, Grid, TextField} from "@mui/material";
import {useState} from "react";
import {INewCcValorDistribuivel} from "@models/contaContabil/valorDistribuivel/INewCcValorDistribuivel.ts";
import dayjs from "dayjs";
import {DefaultDatePicker} from "@shared/custom/DefaultDatePicker.tsx";
import {MoneyInputEntry} from "@components/shared/FormEntries/InputEntry.tsx";
import {useGeneral} from "@contexts/GeneralContext.tsx";
import {DatePicker} from "@mui/x-date-pickers";
import {SaveOutlined} from "@mui/icons-material";
import {__contacontabil_endpoints} from "@components/contaContabil/endpoints/__contacontabil_endpoints.ts";
import {useAlert} from "@contexts/hooks/useAlert.ts";
import {useApi} from "@contexts/hooks/api/useApi.ts";

interface CreateCcDistribuivelProps {
	ContaContabilId?: number
}

export function CreateCcDistribuivel(props: CreateCcDistribuivelProps) {
	const {adjustSizeLevel} = useGeneral()
	const {Get} = useApi()
	const {createAlert} = useAlert()

	const [form, setForm] = useState<INewCcValorDistribuivel | undefined>({
		contaContabilId: props.ContaContabilId ?? 0,
		dataFim: dayjs().add(1, 'month'),
		dataInicio: dayjs(),
		nome: "",
		valor: 0
	})

	const handleSend = () => {
		if (form == null) {
			createAlert('Preencha o formulario', 'warning', 2000)
			return;
		}

		if (form.nome.length < 3) {
			createAlert('Nome deve ter pelo menos 3 caracteres', 'warning', 2000)
			return;
		}

		if (form.dataInicio >= form.dataFim) {
			createAlert('Data de inicio deve ser menor que a data de fim', 'warning', 2000)
			return;
		}
		Get(__contacontabil_endpoints.CreateCcValorDistribuivel(form)).then(x => console.log(x))
	}


	return (form != null && <Grid container>
		<Grid size={adjustSizeLevel({sm: 12, md: 6})}>
			<TextField value={form.nome} label={'Nome'} onChange={(e) => {
				setForm({...form, nome: e.target.value})
			}}/>
		</Grid>
		<Grid size={adjustSizeLevel({sm: 12, md: 6})}>
			<MoneyInputEntry value={form.valor} label={'Valor'} onChange={(v) => {
				if (v != null)
					setForm({...form, valor: v})
			}}/>
		</Grid>
		<Grid size={adjustSizeLevel({sm: 12, md: 6})}>
			<DefaultDatePicker value={form.dataInicio} label={'Inicio da vigencia'} catchValue={(v) => {
				if (v != null)
					setForm({...form, dataInicio: v})
			}}/>
		</Grid>
		<Grid size={adjustSizeLevel({sm: 12, md: 6})}>
			<DatePicker value={form.dataFim}
			            label={'Fim da vigencia'}
			            onChange={(v) => {
				            setForm({...form, dataFim: dayjs(v)})
			            }}/>
		</Grid>
		<Grid size={12}>
			<Grid container justifyContent={'flex-end'}>
				<Grid>
					<Button onClick={handleSend} endIcon={<SaveOutlined/>}>Salvar</Button>
				</Grid>
			</Grid>
		</Grid>
	</Grid>)
}
